"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewBuilderUtil = void 0;
const StoryNodeDisplayType_1 = require("../../base/storyV2/domain/StoryNodeDisplayType");
const CotTemplateResponseData_1 = require("../cot/typed/CotTemplateResponseData");
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
/**
 * 转换graph的工具类方法
 * 后期graph和cot的graph统一后可删除
 */
class ViewBuilderUtil {
    /**
     * 将graph转为cot graph一样的结构
     * @param graph CotTemplateGraph
     * @returns
     */
    static handleGraph(graph) {
        const translateType = this.translateType.bind(this);
        const translateNodeData = this.translateNodeData.bind(this);
        const idMap = new Map();
        const positionMap = this.orderNodePosition(graph.edges);
        const nodes = [];
        let i = 0;
        graph.nodes.forEach(node => {
            const newId = `${i}`;
            const position = positionMap.get(node.id);
            idMap.set(node.id, newId);
            nodes.push({
                ...node,
                id: newId,
                position,
                type: translateType(node.type),
                data: translateNodeData(node.data),
            });
            i++;
        });
        const edges = graph.edges.map(edge => {
            const source = idMap.get(edge.source) || "";
            const target = idMap.get(edge.target) || "";
            return {
                ...edge,
                source,
                target,
                id: source + "-" + target,
            };
        });
        return { nodes, edges };
    }
    /**
     * 转换type 为了和cot graph的type保持一致
     * 后期接口统一后就无需再转换
     * @param type NodeType
     * @returns
     */
    static translateType(type = CotTemplateResponseData_1.NodeType.USERINPUT) {
        switch (type) {
            case CotTemplateResponseData_1.NodeType.INPUT:
                return CotTemplateResponseData_1.NodeType.USERINPUT;
            default:
                return type;
        }
    }
    /**
     * 转换node的type
     * @param type StoryNodeDisplayType
     * @returns
     */
    static getDisplayType(type, components = []) {
        if (components.length > 0) {
            return StoryNodeDisplayType_1.StoryNodeDisplayType.BLUEPRINT;
        }
        return type;
    }
    /**
     * 转换noda.data 为了和cot graph的data保持一致
     * 后期接口统一后就无需再转换
     * @param type NodeData
     * @returns
     */
    static translateNodeData(data) {
        const node_type = this.getDisplayType(data.type, data.components);
        const content = this.getNodeContent(data);
        return {
            ...data,
            node_type,
            content,
        };
    }
    static getNodeContent(data) {
        if (data.components?.length === 0) {
            return data.value;
        }
        return {
            data: {
                value: "",
                list: false,
                type: "text",
                description: "",
                components: data.components,
                name: data.name,
            },
            message: "",
        };
    }
    /**
     * 根据edges解析graph结构 返回node的positon
     * @param edges
     * @returns
     */
    static orderNodePosition(edges) {
        const positionMap = new Map();
        let x = 0;
        let y = 0;
        edges.forEach(edge => {
            const sourceBlank = (0, is_blank_1.default)(positionMap.get(edge.source));
            const targetBlank = (0, is_blank_1.default)(positionMap.get(edge.target));
            if (sourceBlank && targetBlank) {
                positionMap.set(edge.source, { x, y });
                x++;
                // 必须先加
                positionMap.set(edge.target, { x, y });
            }
            else if (!targetBlank) {
                y++;
                x--;
                positionMap.set(edge.source, { x, y });
            }
            else if (!sourceBlank) {
                y = 0;
                x += 2;
                positionMap.set(edge.target, { x, y });
            }
        });
        return positionMap;
    }
}
exports.ViewBuilderUtil = ViewBuilderUtil;
